import { useState } from 'react'
import useHttpLoader from '../../../../hooks/useHttpLoader'
import authApi from '../../auth.api'
import { useSetRecoilState } from 'recoil'
import authAtom from '../../auth.atom'

const useAuthPage = () => {
  const setAuthState = useSetRecoilState(authAtom)
  const { wait, loading } = useHttpLoader()

  const [agreementApproved, setAgreementApproved] = useState(false)
  const [error, setError] = useState('')
  // phone number or email
  const [contact, setContact] = useState('')
  const [contactValid, setContactValid] = useState(false)
  const [contactSubmitted, setContactSubmitted] = useState(false)
  const [confirmationCode, setConfirmationCode] = useState('')

  // 0 - email, 1 - phone
  const [contactType, setContactType] = useState(0)

  const handleAgreementToggle = () => setAgreementApproved((prev) => !prev)

  const handleContactChange = (value: string) => {
    setContact(value)
    setContactValid(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/.test(value))
  }

  const handleContactTypeChange = (contactIndex: number) => {
    if (contactIndex !== contactType) {
      setContact('')
      setContactType(contactIndex)
    }
  }

  const handleContactConfirmCancel = () => {
    setError('')
    setContactSubmitted(false)
    setConfirmationCode('')
  }

  const handleContactSubmit = () => {
    const payload = contactType === 0 ? { email: contact } : { phone: contact }
    const request = authApi.submitContact(payload)

    wait(request, (resp) => {
      if (resp.status === 'error') return setError(resp.message)

      setContactSubmitted(true)
    })
  }

  const handleContactConfirm = () => {
    const payload = contactType === 0 ? { email: contact } : { phone: contact }

    wait(authApi.confirmContactWithInitDataInit(payload, confirmationCode), (resp) => {
      if (resp.status === 'error') return setError(resp.message)

      const { refresh, accessExpires, access, refreshExpires } = resp.body.tokens
      localStorage.setItem('refresh', refresh)

      setAuthState({ accessToken: access, accessExpires, refreshToken: refresh, refreshExpires })
    })
  }

  return {
    contact,
    contactValid,
    handleContactChange,
    confirmationCode,
    setConfirmationCode,
    handleContactSubmit,
    handleContactConfirm,
    handleContactConfirmCancel,
    contactSubmitted,
    loading,
    error,
    agreementApproved,
    handleAgreementToggle,
    contactType,
    handleContactTypeChange,
  }
}

export default useAuthPage
